module.exports = __webpack_public_path__ + "assets/fce1d00baddb71e21d1bf3c898c1a4d8.png";